"use client";

import { signOut } from "@/app/login/actions";
import { ReactNode } from "react";

export default function SignOutButton({
  className,
  icon,
}: {
  className?: string;
  icon?: ReactNode;
}) {
  return (
    <form action={signOut} className="w-full">
      <button
        type="submit"
        className={className ?? "rounded-lg border px-3 py-2 text-sm"}
      >
        {icon}
        <span>Sign out</span>
      </button>
    </form>
  );
}
